'use strict'

const { extract, parse } = require('query-string')
const get_ = require('lodash/get')
const includes_ = require('lodash/includes')
const result = require('folktale/result')
const maybe = require('folktale/maybe')

const DEV_QUERY_PARAMS = [
  'ReactSource',
  'EditorSource',
  'experiments',
  'petri_ovr',
  'WixCodeRuntimeSource',
  'js-wixcode-sdk-override'
]

const doesNotContainDevQueryParameter = queryParameters =>
  Object.keys(queryParameters).every(key => !includes_(DEV_QUERY_PARAMS, key))

const getUrlsFromData = data => [
  get_(data, ['request', 'headers', 'Referer']),
  get_(data, ['request', 'url'])
]

const shouldSendReportByUrl = url =>
  maybe
    .fromNullable(url)
    .chain(url => result.try(() => parse(extract(url))))
    .map(queryParameters => doesNotContainDevQueryParameter(queryParameters))
    .getOrElse(true)

const shouldSendReport = data =>
  getUrlsFromData(data).every(shouldSendReportByUrl)

module.exports = shouldSendReport



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/raven/shouldSendReport.js